import { Quill } from "react-quill";

const quillGlobal: any = typeof window !== "undefined" ? window.Quill || Quill : Quill;

let PageBreakBlot: any = null;

if (quillGlobal) {
  const BlockEmbed = quillGlobal.import("blots/block/embed");

  PageBreakBlot = class extends BlockEmbed {
    static blotName = "page-break";
    static tagName = "div";
    static className = "ql-page-break";

    static create(value: any) {
      const node = super.create(value);
      node.setAttribute("contenteditable", "false");
      node.innerHTML = '<span class="ql-page-break-label">Page Break</span>';
      return node;
    }
  };

  quillGlobal.register(PageBreakBlot);
}

export default PageBreakBlot;
